import React from 'react'
import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
} from '@/shared/components/ui/empty'
import { cn } from '@/shared/lib/utils'

export default function WidgetErrorStateInside({
	size = 'medium',
}: {
	size?: 'small' | 'medium'
}) {
	const { t } = useTranslation()

	return (
		<Empty
			className={cn('h-full', {
				'gap-0 p-0 md:p-0': size === 'small',
			})}
		>
			<EmptyHeader>
				<EmptyMedia
					variant='icon'
					className='bg-destructive/20 text-destructive'
				>
					<AlertTriangleIcon />
				</EmptyMedia>
				<EmptyDescription
					className={cn('text-destructive', {
						'text-xs': size === 'small',
					})}
				>
					{t('error.unrecoverable.title')}
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
